import Icon from '@mdi/react';
import { Box, MenuItem, SxProps } from '@mui/material';
import React from 'react';
import { vars } from '../../../Theme';

/**
 * Component for an item in a Context Menu.
 */
export default (props: IContextMenuItemProps) => {
    /** Deconstruct props. */
    const { text, icon, color, onClick, disabled, sx } = props;

    return (
        <MenuItem onClick={onClick} disabled={disabled} sx={sx}>
            <Icon path={icon} color={color ?? vars.font} size={1.1} />

            <Box sx={{ ml: 1.5 }}>{text}</Box>
        </MenuItem>
    );
};

/**
 * Interface that describes the props for a ContextMenuItem component.
 */
export interface IContextMenuItemProps {
    /** Item display text. */
    text: string;

    /** Item SVG icon. */
    icon: string;

    /** Item onClick handler. */
    onClick: (e: React.MouseEvent) => void;

    /** Icon's color. */
    color?: string;

    /** (Optional) Item disabled state. */
    disabled?: boolean;

    /** (Optional) Item sx styles. */
    sx?: SxProps;
}
